var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screenWidth>600)?_c('top-header_web'):_c('top-header_h5')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }